import store from './store/configureStore'
import actions from './auth/actions'


export default () =>
    new Promise(() => {
        store.dispatch(actions.checkAuthorization())
    });
